function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function getBackendUrl() {
  return getConfig("VITE_BACKEND_URL");
}

// Monta a URL de um arquivo servido pelo backend.
//
// A VITE_BACKEND_URL do projeto termina com "/", e o codigo escrevia
// `${getBackendUrl()}/public/...` — o resultado tinha barra dupla e o Express
// devolvia 404. A logo do white-label nunca aparecia por causa disso.
export function getPublicFileUrl(nomeDoArquivo) {
  if (!nomeDoArquivo) return "";

  const base = String(getBackendUrl() || "").replace(/\/+$/, "");
  const arquivo = String(nomeDoArquivo).replace(/^\/+/, "");

  return `${base}/public/${arquivo}`;
}

// Id do app da Meta usado no login de Facebook e Instagram na tela de
// Conexões. Vazio esconde os botões — é o que mantém a tela utilizável em
// quem não configurou o app.
export function getFacebookAppId() {
  return getConfig("VITE_FACEBOOK_APP_ID");
}

// Configuração do Login for Business, por canal.
//
// Apps criados como "Business" não aceitam permissão solta em `scope`: elas
// ficam numa configuração criada no painel, e o login referencia o id dela.
// Pedir por scope nesses apps devolve "Invalid Scopes". Vazio = o app é do
// login clássico e o botão continua pedindo por scope.
export function getFacebookConfigId(canal) {
  return getConfig(`VITE_FACEBOOK_CONFIG_ID_${canal.toUpperCase()}`);
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}
